import SectionHeading from './SectionHeading';

const topics = [
  {
    id: 'g1',
    icon: 'ri-film-line',
    title: '新片与经典怎么区分',
    paragraphs: [
      '新片强调的是近期公开的方向，更新节奏更快、题材更集中；经典则指已经形成稳定评价的一批内容。两者的差别不在质量高低，而在于你当前更想快速跟进，还是想做整体回顾。',
      '如果只是先了解一下，可以从新片速览按题材挑选；如果想看风格演变，则更适合从作品年表的阶段划分入手，横向比较不同时期的表达差异。',
    ],
  },
  {
    id: 'g2',
    icon: 'ri-image-2-line',
    title: '写真与影像的区别',
    paragraphs: [
      '写真通常以静态画面为主，强调色调、构图与质感；影像则以动态片段为主，除画面外还包含节奏与场景连贯性。两者的浏览方式不同，前者适合按风格挑选，后者更适合按主题整段观看。',
      '本页把写真与影像按色调和场景归入同一分区，是为了让按视觉偏好浏览的读者更省事，而不是把它当作统一类型。',
    ],
  },
  {
    id: 'g3',
    icon: 'ri-shield-check-line',
    title: '如何核对消息与近况',
    paragraphs: [
      '核对消息时，先看是否来自官方账号或受认可的公开渠道，再看是否带有原文出处。只截取片段、缺少来源、或语气明显夸张的内容，建议先保留判断，避免把二次转述当成本人表态。',
      '近况信息容易随时间变化，建议以最新发布的公开信息为准，并把本页内容当作方向性整理，而不是最终结论。',
    ],
  },
];

const glossary = [
  { term: '新片', desc: '近期公开的作品方向，更新较快。' },
  { term: '写真', desc: '以静态画面为主，强调色调与质感。' },
  { term: '影像', desc: '以动态片段为主，含节奏与场景连贯性。' },
  { term: '企划', desc: '围绕特定主题或合作展开的一组内容。' },
  { term: '近况', desc: '一段时间内的整体动向，按线索汇总。' },
  { term: '花絮', desc: '正片之外的幕后片段与访谈内容。' },
];

export default function GuideSection() {
  return (
    <section id="guide" className="anchor-offset bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="主题解读"
          title="看懂分区背后的判断方式"
          description="为了让你更快找到需要的信息，这里补充几点常见疑问的说明：如何区分新片与经典、写真与影像各自适合怎样的浏览方式，以及核对消息时该注意什么。"
        />

        <div className="grid gap-6 lg:grid-cols-[1.4fr_0.6fr]">
          <div className="space-y-5">
            {topics.map((topic) => (
              <article key={topic.id} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <h3 className="flex items-center gap-2.5 font-heading text-lg font-bold text-foreground-950">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${topic.icon} text-base`}></i>
                  </span>
                  {topic.title}
                </h3>
                <div className="mt-3 space-y-3">
                  {topic.paragraphs.map((text, index) => (
                    <p key={index} className="text-sm leading-relaxed text-foreground-600 md:text-base">
                      {text}
                    </p>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <aside className="h-fit rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-book-2-line text-accent-600"></i>
              术语小词典
            </h3>
            <dl className="mt-4 space-y-3">
              {glossary.map((item) => (
                <div key={item.term} className="rounded-md bg-background-50 p-3">
                  <dt className="font-heading text-sm font-bold text-foreground-900">{item.term}</dt>
                  <dd className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </div>
    </section>
  );
}